// Module
var code = "<mb-dynamic-form ng-model=\"ctrl.data\" ng-change=\"ctrl.updateData(ctrl.data)\" mb-parameters=\"ctrl.properties\"> </mb-dynamic-form> ";
// Exports
var _module_exports =code;;
var path = '/viraweb123/vw-dashboard/src/modules/core/wizards/model-transition-data/transition-properties.html';
window.angular.module('mblowfishApp').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;